import { Button } from '@chakra-ui/react';
import { Component, ErrorInfo, ReactNode } from 'react';
import { PanelCardContainer } from './style';
import { PanelCardProps } from './types';

class ErrorBoundary extends Component<
  { children: ReactNode; onRefreshClick: () => void },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode; onRefreshClick: () => void }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('PanelCard Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="panel-card-error-container">
          <div className="panel-card-error">
            Some error occurred while loading the chart. <br /> Please refresh
          </div>
          <Button size="xs" mt={4} onClick={this.props.onRefreshClick}>
            Refresh
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

function PanelCard({
  title,
  onExportClick,
  children,
  chartDescription,
  topElement,
}: PanelCardProps) {
  const onRefreshClick = () => {
    console.log('refresh');
  };

  return (
    <PanelCardContainer>
      {onExportClick && (
        <div className="panel-card-header">
          <div className="panel-card-header-title">{title}</div>
          <div>
            <Button variant="ghost" size="xs" onClick={onExportClick}>
              <div className="panel-card-header-export-icon" style={{ marginRight: '4px' }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25806 7.34717C1.53866 7.34717 1.76613 7.57464 1.76613 7.85523V10.0642C1.76613 10.1577 1.84195 10.2336 1.93548 10.2336H10.0645C10.158 10.2336 10.2339 10.1577 10.2339 10.0642V7.85523C10.2339 7.57464 10.4613 7.34717 10.7419 7.34717C11.0225 7.34717 11.25 7.57464 11.25 7.85523V10.0642C11.25 10.7189 10.7192 11.2497 10.0645 11.2497H1.93548C1.28076 11.2497 0.75 10.7189 0.75 10.0642V7.85523C0.75 7.57464 0.977468 7.34717 1.25806 7.34717Z"
                    fill="#1B7FF1"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.01788 8.84717C5.73729 8.84717 5.50982 8.6197 5.50982 8.3391L5.50982 2.14351L3.90308 3.75024C3.70467 3.94866 3.38298 3.94866 3.18457 3.75024C2.98616 3.55183 2.98616 3.23014 3.18457 3.03173L5.07549 1.14082C5.59596 0.620343 6.43981 0.620343 6.96028 1.14082L8.85119 3.03173C9.0496 3.23014 9.0496 3.55183 8.85119 3.75024C8.65278 3.94866 8.33109 3.94866 8.13268 3.75024L6.52595 2.14351L6.52595 8.3391C6.52595 8.6197 6.29848 8.84717 6.01788 8.84717Z"
                    fill="#1B7FF1"
                  />
                </svg>
              </div>
              Export Data
            </Button>
          </div>
        </div>
      )}
      <div className="panel-card-body">
        <ErrorBoundary onRefreshClick={onRefreshClick}>
          {topElement}
          {chartDescription && <div className="panel-card-body-chart-desc">{chartDescription}</div>}
          {children}
        </ErrorBoundary>
      </div>
    </PanelCardContainer>
  );
}

export default PanelCard;
